function CourseListShow() {
	$('.js-course-list-show').on("click", function() {
		$('.js-course-list-bottom').fadeOut();
		$('.js-course-list-wrapper').addClass('is-full');
	});
}

export { CourseListShow };